const formElementNode = document.getElementById('formularioPedido');

if (formElementNode)
	formElementNode.onchange = () => formValidationInputs(formElementNode);

/**
 * ENABLE SUBMIT BUTTON
 * @param {HTMLElement} formElement
 * @param {boolean} state
 */
function changeSubmitButtonState(formElement, state) {
	const submitButton = formElement.querySelector("button[type='submit']");

	submitButton.disabled = !state;
}

/**
 * ENABLE SUBMIT BUTTON
 * @param {HTMLElement} formElement
 */
function formValidationInputs(formElement) {
	const inputElements = [
		...formElement.querySelectorAll('div[data-bs-inputvalidated-controller]')
	];

	const successInputs = inputElements.filter((i) => {
		const attributeState =
			i.attributes.getNamedItem('data-bs-inputValidated-state')?.value ??
			undefined;
		return attributeState != undefined && attributeState == 'success';
	});

	const submitButtonState = inputElements.length == successInputs.length;
	changeSubmitButtonState(formElement, submitButtonState);
}

/**
 * ENABLE SUBMIT BUTTON
 * @param {HTMLElement} formElement
 */
function clearAllFoormFields(formElement) {
	const inputElements = [
		...formElement.querySelectorAll('div[data-bs-inputvalidated-controller]')
	];

	inputElements.forEach((child) => {
		const inputNode = child.querySelector('input');
		inputNode.value = '';

		child.attributes.removeNamedItem('data-bs-inputValidated-state');
		child.attributes.removeNamedItem('data-bs-inputValidated-message');
	});

	changeSubmitButtonState(formElement, false);
}

const startat = document.getElementById('field-date-startat');
const endat = document.getElementById('field-date-endat');

let hoje = new Date();
var dataLimite = new Date('2024-04-17');


if (startat) {
	startat.setAttribute('max', formateDate(hoje));
}

if (endat) {
	endat.setAttribute('max', formateDate(hoje));

	if (hoje > dataLimite) {
		// endat.value = formateDate(dataLimite);
		endat.setAttribute('max', formateDate(dataLimite));

	}
}
